import { render, staticRenderFns } from "./DigitalManagerGuru.vue?vue&type=template&id=4490d54b&scoped=true&"
import script from "./DigitalManagerGuru.vue?vue&type=script&lang=js&"
export * from "./DigitalManagerGuru.vue?vue&type=script&lang=js&"
import style0 from "./DigitalManagerGuru.vue?vue&type=style&index=0&id=4490d54b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4490d54b",
  null
  
)

export default component.exports